import * as types from './types'

export const initialState = {
  endpoint: null,
  wishlistToggleEndpoint: null,
  googleApiKey: null,

  order: 'featured',

  filters: {
    types: [],
    minBedrooms: null,
    maxBedrooms: null,
    minBeds: null,
    maxBeds: null,
    minBudget: null,
    maxBudget: null,
    amenities: [],
  },

  loading: false,

  results: [],

  pagination: {
    count: 0,
    pages: 0,
    page: 0,
    amenities: {},
    types: {},
  },

  activeProperty: null,

  activeFilterScreen: null,
}

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case types.SET_ORDER:
      return {
        ...state,
        order: payload.order,
      }

    case types.STORE_RESULTS:
      return {
        ...state,
        results: payload.results,
        pagination: {
          count: payload.count,
          pages: payload.pages,
          page: payload.page,
          amenities: payload.amenities,
          types: payload.types,
        },
        activeProperty: null,
      }

    case types.TOGGLE_WISHLIST_SUCCESS:
      return {
        ...state,
        results: state.results.map((item) => {
          if (item.uuid === payload.property) {
            return {
              ...item,
              wishlisted: payload.wishlisted,
            }
          }

          return item
        }),
      }

    case types.LOADING_START:
      return {
        ...state,
        loading: true,
      }

    case types.LOADING_END:
      return {
        ...state,
        loading: false,
      }

    case types.SET_ACTIVE_PROPERTY:
      return {
        ...state,
        activeProperty: payload.property,
      }

    case types.SHOW_FILTER:
      return {
        ...state,
        activeFilterScreen: state.activeFilterScreen === payload.type ? null : payload.type,
      }

    case types.HIDE_FILTER:
      return {
        ...state,
        activeFilterScreen: null,
      }

    case types.APPLY_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/search/index.js